<template>
  <div class="app-container" v-if="form">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="title-box"><span class="txt1">基础信息</span></div>
      <el-descriptions>
        <el-descriptions-item label="活动名称">{{form.activityName}}</el-descriptions-item>
        <el-descriptions-item label="活动方式">{{form.activityWay === 1?'指定商品':(form.activityWay === 2?'平台满赠':'')}}</el-descriptions-item>
        <el-descriptions-item label="是否限制时间">{{form.timeLimit === 1?'限制':'不限制'}}</el-descriptions-item>
        <el-descriptions-item label="活动时间（北京时间）">{{Number(form.timeLimit) === 1 ? `${formatActivityTime(form.startTime)} 至 ${formatActivityTime(form.endTime)}` : '不限时'}}</el-descriptions-item>
      </el-descriptions>
      <!-- BUG-2026-660473：详情页同样显示时间状态和上架状态 -->
      <time-status :time-limit="form.timeLimit" :start-time="form.startTime" :end-time="form.endTime" :now="now" :activity-status="form.activityStatus" show-listing />
      <div class="custom bg">活动规则：{{form.activityRule}} </div>
      <div class="custom bg">参与活动身份：<span v-for="(item,index) in form.customerLevelList" :key="index">{{item.name}}{{form.customerLevelList.length - 1 != index?',':''}}</span> </div>
      <div class="custom bg">
        参与付款方式：{{payModesText(form.payModes, form.activityModules)}}
        <span class="tip" v-if="isPayModesDerived(form.payModes)">（未显式配置，按参与活动条件推导）</span>
      </div>
      <div class="title-box"><span class="txt1">活动商品</span></div>
      <el-descriptions>
        <el-descriptions-item label="活动类型">{{form.activityType === 1?'满件赠':(form.activityType === 2?'满金额赠':'')}}</el-descriptions-item>
        <el-descriptions-item label="赠送方式">{{form.givingWay === 1?'平台随机赠送':(form.givingWay === 2?'客户自定赠送商品':'')}}</el-descriptions-item>
        <el-descriptions-item label="是否叠加条件">{{form.activityCondition?'叠加':'不叠加'}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="赠送规则"></el-descriptions>
      <el-table :data="form.activityConditionList">
        <el-table-column label="赠送门槛" prop="fullNum" align="center">
          <template slot-scope="{row}">
            满{{row.fullNum}}{{form.activityType === 1?'件':'元'}}
          </template>
        </el-table-column>
        <el-table-column label="赠品类型" align="center">
          <template slot-scope="{row}">
            {{rewardTypeText(row.rewardType)}}
          </template>
        </el-table-column>
        <el-table-column label="赠送内容" align="center">
          <template slot-scope="{row}">
            {{rewardText(row)}}
          </template>
        </el-table-column>
      </el-table>
      <div class="custom bg">活动商品：<span v-for="(item,index) in form.sysGoodsList" :key="index">{{item.name}}{{form.sysGoodsList.length != index?',':''}}</span> </div>
      <el-descriptions title="赠送商品"></el-descriptions>
      <el-table :data="form.sysGoodsSpecValuecombineList">
        <el-table-column label="商品" prop="goodsName" align="center">
          <template slot-scope="{row}">
            {{row.goodsName || row.aliasTitle}}
          </template>
        </el-table-column>
        <!-- 原来这列绑的是 row.spec，但 sysGoodsSpecValuecombineList 的 VO 里没有 spec 字段，
             所以一直显示「无规格值」。改绑真实存在的 specName（SKU 规格名）。 -->
        <el-table-column label="规格" align="center">
          <template slot-scope="{row}">
            {{row.specName || '无规格值'}}
          </template>
        </el-table-column>
        <!-- REQ-2026-234328 商品规格（如「10片/盒」），与 SKU 规格名是两个维度。
             回收 product_spec 后取 sys_goods.spec，字段名 productSpec 保留为别名。 -->
        <el-table-column label="商品规格" align="center">
          <template slot-scope="{row}">
            {{row.productSpec || '-'}}
          </template>
        </el-table-column>
      </el-table>
      <el-descriptions class="mt10">
        <el-descriptions-item label="状态">{{form.activityStatus?'上架':'下架'}}</el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
import goodsActivityApi from '@/api/goods/goodsActivity'
import { payModesText, isPayModesDerived, rewardTypeText, rewardText } from './activityEnum'
import timeStatus from './timeStatus'
import { formatActivityTime } from './activityTime'
export default {
  props: ['rowItem'],
  components: { timeStatus },
  data() {
    return {
      now: Date.now(),
      clockTimer: null,
      activeName: 'first',
      list: [],
      form: {},
      tabType: 1
    }
  },
  created() {
    this.clockTimer = setInterval(() => {
      this.now = Date.now()
    }, 1000)
    this.handleShow()
  },
  beforeDestroy() {
    clearInterval(this.clockTimer)
    this.clockTimer = null
  },
  methods: {
    formatActivityTime,
    payModesText,
    isPayModesDerived,
    rewardTypeText,
    rewardText,
    handleShow() {
      goodsActivityApi.fetchById(this.rowItem.id)
        .then((data) => {
          this.form = data.data;
        })
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  }

}
</script>

<style lang="scss" scoped>
.tip {
  font-size: 12px;
  color: #878787;
}
.custom {
  font-size: 14px;
  color: #2e2f3e;
  padding: 20px;
  margin: 10px 0;
  &.bg {
    // border-bottom: 1px solid #CCE2D1
    background-color: #eff8fd;
  }
}
.title-box {
  margin-bottom: 10px;
  margin-right: 24px;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-right: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
</style>
